import React from 'react';
import { Card } from '../components/ui/card';

function ReturnsPolicyPage() {
  return (
    <div className="min-h-screen py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl font-display font-normal mb-8">Returns & Refunds Policy</h1>
        
        <Card className="p-6 space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Return & Refund Policy</h2>
            <p className="text-muted-foreground">
              We want you and your kids to love our products! Returns and refunds are applicable 
              <strong> only if the product is received damaged</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Eligibility for Returns & Refunds</h2>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-amber-800 font-medium">
                ⚠️ Returns and refunds are ONLY applicable for damaged products received during delivery.
              </p>
            </div>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Only damaged products</strong> are eligible for return or refund</li>
              <li>Return request must be initiated within 7 working days of delivery</li>
              <li>Please share clear photos of the damage when requesting a return</li>
              <li>Original packaging should be retained if possible</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Non-Returnable Items</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Products that are not damaged during delivery</li>
              <li>Products that have been used or washed</li>
              <li>Change of mind or wrong size selection</li>
              <li>Products purchased during special sales (if specified)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">How to Report a Damaged Product</h2>
            <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
              <li>Contact us within 7 working days of receiving the product</li>
              <li>Share clear photos of the damaged product via WhatsApp or email</li>
              <li>Our team will review and approve your request within 24 hours</li>
              <li>Pack the product securely in original packaging</li>
              <li>Our courier partner will pick up the product from your address</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Refund Process</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Refunds are processed within 5-7 business days after we receive the damaged product</li>
              <li><strong>Refund will be credited to the original payment method used during purchase</strong></li>
              <li>You'll receive an email/WhatsApp notification once the refund is processed</li>
              <li>Bank processing may take additional 3-5 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Replacement Option</h2>
            <p className="text-muted-foreground">
              For damaged products, you can choose either a full refund or a replacement product 
              (subject to availability). Please specify your preference when reporting the damage.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              For return queries, contact us:
            </p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li><strong>F Square Media</strong></li>
              <li>Address: Panchsheel Park, New Delhi - 110017</li>
              <li>Email: motheringin@gmail.com</li>
              <li>Phone/WhatsApp: +91 80621 80632</li>
            </ul>
          </section>
        </Card>
      </div>
    </div>
  );
}

export default ReturnsPolicyPage;